import axios from 'axios';

class ApiService {
    archivePmRecords(payload) {
        return axios.post('archive/pm/catching/records', payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error.data;
        });
    }

    getDuplicateRecords(projectId) {
        return axios.get(`catch_release/catching/duplicate/records/${projectId}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error.data;
        });
    }

    mergeDuplicateRecords(projectId) {
        return axios.post(`catch_release/catching/merge/duplicate/records/${projectId}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error.data;
        });
    }

    getSurgeonStatistics(projectId, payload) {
        return axios.post(`pm/reports/vetwise/${projectId}`, payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error.data;
        });
    }

    getOverallReport(projectId, payload) {
        return axios.post(`pm/reports/overall/${projectId}`, payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error.data;
        });
    }

    getSurgeryMonthlyReport(projectId, payload) {
        return axios.get(`pm/reports/surgery/monthly/${projectId}?month=${payload}`)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error.data;
        });
    }

    downloadSurgeyMonthlyReport(projectId, payload) {
        return axios.get(`pm/reports/surgery/monthly/${projectId}?month=${payload.month}&format=${payload.format}`, {
            responseType: 'blob'
        })
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error.data;
        });
    }

    getPmDateWiseReport(projectId, payload) {
        return axios.post(`pm/reports/datewise/${projectId}`, payload)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            return error.data;
        });
    }
}

export default new ApiService();